import React from 'react';
import { Link } from 'react-router-dom';
import './NotFound.scss'; 

const NotFound = () => {

  //const userData = JSON.parse(localStorage.getItem('user_data'));
 
// Conditionally render based on user role
  const renderHomepageLink = () => {
   /* if (userData?.role === 'manager') {
      return <Link to="/manager">Go back to Manager Homepage</Link>;
    } else if (userData?.role === 'employee') {
      return <Link to="/employee">Go back to Employee Homepage</Link>;
    } else {
      return <Link to="/admin">Go back to the Homepage</Link>;
    }*/
     return <Link to="/">Go to the Login Page</Link>;
  };
  
  //<button onClick={() => window.location.reload()}>Reload</button>


  return (
    <div className="not-found-container">
      
      <h1>Oops! Page Not Found</h1>

      <p>The page you're looking for doesn't exist or has been moved.</p>
      
      {/* Render the link based on role */}
      {renderHomepageLink()}
    </div>
  );
};

export default NotFound;
